import { PanelResizeHandle } from "react-resizable-panels";
import { faArrowsAltH } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styling.scss";

const ResizeHandle = () => {
	return (
		<PanelResizeHandle className="resize-handle">
			<span>
				<FontAwesomeIcon icon={faArrowsAltH} style={{ height: 16, width: 16 }} />
			</span>
		</PanelResizeHandle>
	);
};

export default ResizeHandle;
